import { render, staticRenderFns } from "./DossierGeneralInfoPanel.vue?vue&type=template&id=56a53cfc&scoped=true"
import script from "./DossierGeneralInfoPanel.vue?vue&type=script&lang=ts"
export * from "./DossierGeneralInfoPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a53cfc",
  null
  
)

export default component.exports